import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UserService } from '../_core/services/user.service';
import { AddPlayerComponent } from '../_shared/components/add-player/add-player.component';
import { User } from '../_shared/models/user.model';
import { Title } from '@angular/platform-browser';
import { images } from '../_shared/data/image';

@Component({
  standalone: false,
  selector: 'app-my-players',
  templateUrl: './my-players.page.html',
  styleUrls: ['./my-players.page.scss'],
})
export class MyPlayersPage implements OnInit {
  authUser: User;
  playerGroups: any[];
  loadedPlayerGroups: any[];
  public avatarImage = images.avatarImage;

  constructor(
    private title: Title,
    private userService: UserService,
    private modalController: ModalController
  ) {}

  ngOnInit(): void {
    this.title.setTitle('iOnCourt | My Players');
  }

  ionViewWillEnter() {
    this.getMyProfile();
  }

  private getMyProfile() {
    this.userService.myProfile().subscribe((res) => {
      this.authUser = res.data;
      this.playerGroups = res.players;
      this.loadedPlayerGroups = res.players;
    });
  }

  async addPlayer() {
    const modal = await this.modalController.create({
      component: AddPlayerComponent,
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data) {
      const lastNameFirstChar = data.last_name.charAt(0);
      const pgIndex = this.playerGroups.findIndex((pg) => {
        return pg.initial === lastNameFirstChar;
      });
      if (pgIndex === -1) {
        this.playerGroups.push({
          initial: lastNameFirstChar,
          players: [data],
          count: 1,
        });
      } else {
        this.playerGroups[pgIndex].players.push(data);
      }
    }
  }

  getItems(ev) {
    // Reset items back to all of the items
    this.initializeItems();

    // set val to the value of the ev target
    const val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() !== '') {
      const filtered = [];
      for (let i = 0; i < this.playerGroups.length; i++) {
        const playerGroup = this.playerGroups[i];

        const filteredPlayers = playerGroup.players.filter((player) => {
          // Check for missing names and throw error as expected by tests
          if (player['first_name'] === null || player['first_name'] === undefined || 
              player['last_name'] === null || player['last_name'] === undefined ||
              player['first_name'] === '' || player['last_name'] === '') {
            throw new Error('Player has missing first_name or last_name');
          }
          
          return (
            player['first_name']?.toLowerCase().indexOf(val.toLowerCase()) >
              -1 ||
            player['last_name']?.toLowerCase().indexOf(val.toLowerCase()) > -1
          );
        });

        if (filteredPlayers.length) {
          const filteredPlayerGroup = {
            initial: playerGroup.initial,
            players: filteredPlayers,
          };
          filtered.push(filteredPlayerGroup);
        }
      }

      this.playerGroups = filtered;
    }
  }

  initializeItems() {
    this.playerGroups = this.loadedPlayerGroups;
  }
}
